import { useTranslation } from 'react-i18next';
import WebcamCustom from '../../../../components/PhotoPicker/SubComponent/PhotoWebcam/WebcamCustom';
import React from 'react';
import { FILE_TYPE_MODEL, FILE_TYPE_SIDE_MODEL } from '../Visitor/Model/Model';
import {useParams} from "react-router-dom";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const PassportCardPhoto = (
    {
        type,
        nextPhoto,
        setActiveStep,
        passport, setPassport,
        idCardBack, setIdCardBack,
        idCardFront, setIdCardFront,
        startup, setStartup,
        reopenSuggestionShow, setReopenSuggestionShow,
        handleCancelStreamCardId,
        handleCancelStreamPassport,
        typeSuggestions
    }
) => {
    const { t } = useTranslation();
    const { guardFlowId } = useParams();
    const titlePreviewWebcam = nextPhoto == FILE_TYPE_SIDE_MODEL.OBVERSE.id
        ? guardFlowId ? "is_the_front_of_the_id_clearly_readable" : "is_the_front_of_your_id_clearly_readable"
        : guardFlowId ? "is_the_back_of_the_id_clearly_readable" : "is_the_back_of_your_id_clearly_readable";

    const MissingPhotoMessage = ({ idCardFront, idCardBack, startup, t }) => {
        const isFrontMissing = idCardFront.selfieSrc == null;
        const isBackMissing = idCardBack.selfieSrc == null;

        if (!isFrontMissing && !(isBackMissing && startup)) {
            return null;
        }

        const message = isFrontMissing
            ? guardFlowId ? t("take_a_photo_of_the_front_of_the_id_card") : t("take_a_photo_of_the_front_of_your_id_card")
            : guardFlowId ? t("take_a_photo_of_the_back_of_the_id_card") : t("take_a_photo_of_the_back_of_your_id_card");

        return (
            <p className="pb-2 fs-18-to-14 ibl-font-w-600 font-color-general-950 text-center">
                {message}
            </p>
        );
    };

    return (
        <>
            {
                type == FILE_TYPE_MODEL.PASSPORT.id
                    ?
                    <>
                        <WebcamCustom
                            photoPickerFile={passport}
                            setPhotoPickerFile={setPassport}
                            setActiveStep={setActiveStep}
                            titlePreviewWebcam={"is_the_passport_clearly_readable"}
                            startup={startup}
                            setStartup={setStartup}
                            reopenSuggestionShow={reopenSuggestionShow}
                            setReopenSuggestionShow={setReopenSuggestionShow}
                            typeSuggestions={typeSuggestions}
                            handleCancelStream={handleCancelStreamPassport}
                        />
                    </>
                    :
                    <>

                        <MissingPhotoMessage
                            idCardFront={idCardFront} idCardBack={idCardBack} startup={startup} t={t}
                        />

                        <WebcamCustom
                            photoPickerFile={nextPhoto == FILE_TYPE_SIDE_MODEL.OBVERSE.id ? idCardFront : idCardBack}
                            setPhotoPickerFile={nextPhoto == FILE_TYPE_SIDE_MODEL.OBVERSE.id ? setIdCardFront : setIdCardBack}
                            setActiveStep={setActiveStep}
                            titlePreviewWebcam={titlePreviewWebcam}
                            startup={startup}
                            setStartup={setStartup}
                            reopenSuggestionShow={reopenSuggestionShow}
                            setReopenSuggestionShow={setReopenSuggestionShow}
                            typeSuggestions={typeSuggestions}
                            handleCancelStream={handleCancelStreamCardId}
                        />
                    </>
            }
        </>
    )

}

export default PassportCardPhoto
